import { DonutChartData } from "@/components/visualizations/DonutChart/DonutChart";
import SingleBarChart from "@/components/visualizations/SingleBarChart.tsx/SingleBarChart";
import useTranslation from "@/hooks/useTranslation";
import { useTransportImpactPerType } from "@/pages/dashboard/hooks/useTransportImpact";
import Widget from "../../components/Widget/Widget";
import { ImpactMetric } from "../../utils/types";

export default function TransportImpactPerType({ metric }: { metric: ImpactMetric }) {
  const translation = useTranslation();
  const { data, isLoading, isFetching } = useTransportImpactPerType({ metric: metric.key });

  const chartData: DonutChartData =
    data && data?.length > 0 && data?.some((row) => row.transport_impact)
      ? data?.map((row) => ({
          label: row.label,
          value: row.transport_impact?.[metric.key] || 0,
        }))
      : [];

  return (
    <Widget
      title={"Inbound vs outbound transport impact"}
      tooltip={translation["dashboard"]["transport"]["inbound_outbound"]}
    >
      <SingleBarChart
        colorPalette="ordinal_green"
        data={chartData}
        format={metric.formatter}
        loading={isLoading || isFetching}
      />
    </Widget>
  );
}
